





























































import { Component, Mixins } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { IntroducerCsvModel } from './csv-model/IntroducerCsvModel'
import { IntermediariesMeta } from '../model/IntermediariesMeta'
import { IntermediaryMixin } from './TheIntermediaryMixin'
import { ServicingVestingCSVModel } from './csv-model/ServicingVestingCSVModel'

@Component
export default class TheIntermediary extends Mixins(IntermediaryMixin) {
  get intermediaryTableColumn () {
    const column = [
      {
        label: 'Policy Number',
        field: 'policyNumber'
      },
      {
        label: `${this.pageTitle} Name`,
        field: 'name'
      },
      {
        label: `${this.pageTitle} NRIC/FIN/Passport/UEN No.`,
        field: 'nric'
      }
    ]
    if (this.intermediaryRole === 'introducer') {
      column.push({
        label: 'Year 1 Commission ($ / %)',
        field: 'year1Commission'
      })
      column.push({
        label: 'Renewal Commission ($ / %)',
        field: 'renewalCommission'
      })
    } else { // vesting and servicing show this
      column.push({
        label: 'Commission (%)',
        field: 'commissionPct'
      })
    }
    return column
  }

  get newIntermediaryDetails (): FormStructure<IntermediariesMeta> {
    return [
      {
        type: 'radio',
        key: 'isIfamUser',
        label: 'Ifam User',
        buttonName: 'ifam-user',
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ],
        show: (e) => !e.createNewPayee,
        onChange: (oldVal, newVal) => {
          this.newIntermediary.userSystemOid = '' // should reset the oid, to avoid case that the user selection is there but user switch to create new intermediately
          if (newVal) { // if it is ifam user, the add new-intermediary should be set to false
            this.newIntermediary.createNewPayee = false
          }
        }
      },
      {
        type: 'radio',
        key: 'createNewPayee',
        buttonName: 'new-intermediary',
        label: 'Add New Intermediary?',
        show: (model) => { return !model.isIfamUser },
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ],
        onChange: (oldVal, newVal) => {
          // should reset the oid, to avoid case that the user selection is there but user switch to create new intermediately
          this.newIntermediary.userSystemOid = ''
          if (newVal) {
            this.newIntermediary.isIfamUser = false
          }
        }
      },
      {
        key: 'userSystemOid',
        label: 'User',
        options: this.userList,
        show: (e) => !e.createNewPayee,
        onChange: (oldVal, newVal) => {
          // should update the nric, email, name detail
          if (oldVal !== newVal) {
            const intermediary = this.newIntermediary.isIfamUser ? this.getIntermediaryFromPicodedSM(newVal) : this.getIntermediaryFromPayee(newVal)
            this.newIntermediary.name = intermediary.fullName
            this.newIntermediary.nric = intermediary.nric
            this.newIntermediary.email = intermediary.email
          }
        }
      },
      {
        label: 'Select Policy via NBR',
        key: 'isLinkNBR',
        type: 'radio',
        buttonName: 'linkPolicy',
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ],
        onChange: (oldVal, newVal) => {
          // clear all value so that the unwanted data is cleared
          this.newIntermediary.policyNumber = ''
        //   this.newIntermediary.clientPolicyOid = ''
        }
      },
      {
        key: 'policyNumber',
        label: 'Policy To Be Assigned To',
        options: this.listOfPolicy,
        show: (model) => { return model.isLinkNBR }
      },
      {
        key: 'policyNumber',
        label: 'Policy To Be Assigned To',
        show: (model) => { return !model.isLinkNBR }
      },
      {
        key: 'year1Commission',
        label: 'Year 1 Commission ($ / %)',
        show: () => { return this.intermediaryRole === 'introducer' }
      },
      {
        key: 'renewalCommission',
        label: 'Renewal Commission ($ / %)',
        show: () => { return this.intermediaryRole === 'introducer' }
      },
      {
        key: 'commissionPct',
        label: 'Commission (%)',
        type: 'number',
        show: () => { return this.intermediaryRole === 'servicing' || this.intermediaryRole === 'vesting' }
      }
    ]
  }

  get csvModel () {
    const model = this.intermediaryRole === 'introducer' ? IntroducerCsvModel : ServicingVestingCSVModel
    model.ifamList = this.ifamList ? this.ifamList.map(e => {
      return {
        oid: e.oid,
        nric: e?.idNumber,
        name: e?.fullname,
        email: e?.email
      }
    }) : []
    model.nonIfam = this.payeeList ? this.payeeList.map(e => {
      return {
        oid: e.oid,
        nric: e?.payeeNric,
        name: e?.payeeFullname,
        email: e?.payeeEmail
      }
    }) : []
    return model
  }

  get exportCSVObject () {
    if (this.intermediaryRole === 'introducer') {
      const csvData = this.intermediaryData.map(data => {
        return [
          data.policyNumber,
          data.name,
          data.nric,
          data.year1Commission,
          data.renewalCommission
        ]
      })
      const header = ['Policy Number', 'Introducer Name', 'Introducer NRIC/FIN/Passport/UEN No.', 'Year 1 Commission ($/%)', 'Renewal Commission ($/%)']
      return {
        csvData: csvData,
        header: header,
        fileName: 'introducer_list'
      }
    }
    const csvData = this.intermediaryData.map(data => {
      return [
        data.policyNumber,
        data.name,
        data.nric,
        data.commissionPct
      ]
    })
    const header = ['Policy Number', this.intermediaryRole + ' Name', this.intermediaryRole + ' NRIC/FIN/Passport/UEN No.', 'Commission (%)']
    return {
      csvData: csvData,
      header: header,
      fileName: this.intermediaryRole + '_list'
    }
  }
}
